var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.71 3.795a1 1 0 0 0-1.415 0L8 10.27 1.705 3.795a1 1 0 0 0-1.41 0 1 1 0 0 0 0 1.43l6.645 6.83a1.5 1.5 0 0 0 2.12 0l6.65-6.83a1.001 1.001 0 0 0 0-1.43Z"
  })));
};
export default SvgChevronDown;